<div class="select-role-page">
  <header class="select-role-header">
    <img src="./assets/media/logos/landing-dark.svg" alt="EN KKU" class="select-role-logo" />

    <button type="button" class="select-role-logout" (click)="logout()">
      <span>ออกจากระบบ</span>
    </button>
  </header>

  <main class="select-role-content">
    <section class="select-role-card">
      <div class="select-role-user">
        <div>ชื่อ - นามสกุล : {{ fullName }}</div>
        <div>อีเมล : {{ user?.email ?? "-" }}</div>
      </div>

      <p class="select-role-prompt">กรุณาเลือกสิทธิ์การเข้าใช้งาน</p>

      <div class="select-role-grid" [class.single-role]="availableRoles.length === 1">
        @for (role of availableRoles; track role.id) {
        <button
          type="button"
          class="select-role-option"
          [class.selected]="isSelected(role.id)"
          [disabled]="isSubmitting"
          [attr.aria-pressed]="isSelected(role.id)"
          (click)="toggleRole(role)"
        >
          {{ getSelectedLabel(role) }}
        </button>
        }
      </div>

      <!-- <button type="button" class="select-role-continue" [disabled]="!canContinue" (click)="continue()">
        เข้าใช้งาน
      </button> -->
    </section>
  </main>
</div>
